import { transparentize } from "polished";
import styled, { css } from "styled-components";
import { zIndex } from "../../../../constants";
import { buttonResetStyles, screenHeight } from "../../../../utils";
import { colors } from "../../../../utils/colors";

type OuterProps = { isOpen: boolean };

export const Outer = styled.div<OuterProps>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    ${screenHeight};
    visibility: hidden;
    background-color: ${colors.brandMid};
    z-index: ${zIndex.mobileMenu};
    overflow-y: auto;
    transform: translateY(-100%);
    transition: 200ms ease-out all;

    ${({ isOpen }) =>
        isOpen &&
        css`
            visibility: visible;
            transform: translateY(0%);
        `};
`;

export const Quicklinks = styled.div`
    display: flex;
    border-bottom: 1px solid ${transparentize(0.9, colors.white)};

    > * {
        width: 100%;
        height: 75px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:not(:last-child) {
            border-right: 1px solid ${transparentize(0.9, colors.white)};
        }
    }
`;

export const ButtonContainer = styled.div`
    padding: 30px 22px;
    text-align: center;

    a,
    button {
        width: 100%;
    }
`;

export const sharedLinkCss = css`
    ${buttonResetStyles};
    color: ${colors.white};
    text-decoration: none;
    font-weight: 400;
    padding: 0 22px;
    display: block;
    width: 100%;
    text-align: left;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
`;

export const MenuItemsWrapper = styled.div`
    > ul {
        padding: 0;
        margin: 0;

        > li {
            display: block;

			&:first-child {
                border-top: 1px solid ${transparentize(0.9, colors.white)};
			}

            button,
            a {
                ${sharedLinkCss}
				background-color: ${colors.brandMid};
                border-bottom: 1px solid ${transparentize(0.9, colors.white)};
            }

             ul {
                padding: 0;
                margin: 0;
                background-color: ${colors.brandDark};

                > li {
					display: block;

					&:not(:first-child) {
					border-top: 1px solid ${transparentize(0.9, colors.white)};
					}

                    > a {
                        ${sharedLinkCss}
                    }
                }
            }
        }
    }
`;
